import { Box, Button, Heading, Layer, Text } from "grommet";

const TECH_FAILURE_ITEMS = [
  "Lockdown browser failure",
  "Screen-share failure",
  "Webcam failure",
];

export default function OrangeFlagInfoLayer({ onClose }) {
  return (
    <Layer
      position="center"
      modal
      onEsc={onClose}
      onClickOutside={onClose}
      margin="medium"
    >
      <Box width="large" flex={false}>
        <Box
          flex={false}
          direction="row"
          justify="between"
          align="center"
          pad={{ horizontal: "medium", vertical: "small" }}
          border={{ side: "bottom", color: "light-3" }}
        >
          <Heading level={3} margin="none">
            Orange Flag
          </Heading>
          <Button label="Close" onClick={onClose} />
        </Box>

        <Box
          flex={false}
          pad="medium"
          gap="medium"
          style={{ maxHeight: "70vh", overflowY: "auto" }}
        >
          <Text>
            Proctors may now use the Orange Flag when a session needs additional
            review by the Auditing Team but does not necessarily indicate a
            confirmed testing violation.
          </Text>

          <Box gap="small">
            <Text weight="bold">Use an Orange Flag for:</Text>
            <Box as="ul" margin={{ left: "medium" }} gap="small">
              <Text as="li">
                Technology failures with no other concerns, including:
                <Box as="ul" margin={{ top: "xsmall", left: "medium" }}>
                  {TECH_FAILURE_ITEMS.map((item) => (
                    <Text key={item} as="li" size="small">
                      {item}
                    </Text>
                  ))}
                </Box>
              </Text>
              <Text as="li">
                Suspicious tester behavior that should be reviewed more closely
                by the Auditing Team.
              </Text>
              <Text as="li">
                A Live Auditor may ask a proctor to Orange Flag a session if they
                identify something that requires additional review.
              </Text>
            </Box>
          </Box>

          <Text>
            When using the Orange Flag, please include clear notes explaining why
            the session was flagged so the Auditing Team knows exactly what to
            review.
          </Text>
        </Box>

        <Box
          flex={false}
          direction="row"
          justify="end"
          pad={{ horizontal: "medium", vertical: "small" }}
          border={{ side: "top", color: "light-3" }}
        >
          <Button label="Close" primary color="black" onClick={onClose} />
        </Box>
      </Box>
    </Layer>
  );
}
